<template>
  <div class="login-body">
    <Toast/>

    <div class="login-panel"></div>

    <div class="login-content" :style="($vssWidth > 767 && $vssWidth < 1800 ? 'width: 47%' : '')">
      <img src="/assets/layout/images/logo-coface-RVB.png" alt="logo-coface-RVB.png"/>
    <div :class="($vssWidth > 767 ? 'grid' : '')">
        <h1 class="title1">{{ $t("login.title1") }}</h1>
        <h1 class="title2">{{ $t("login.title2") }}</h1>
    </div>
      <p>{{ $t("login.subtitle") }}</p>

      <div class="login-input-wrapper">
        <InputText :placeholder="$t('login.username')" v-model="username" @keyup="refreshUsername++"
                   @keyup.enter="login"/>
      </div>

      <div class="login-input-wrapper">
        <Password id="password" toggleMask :placeholder="$t('login.password')" v-model="password" @keyup.enter="login"
                  style="width: 100%"/>
      </div>

      <Button :disabled="loading" :label="$t('login.signin')" icon="pi pi-check" @click="login"/>
      <ProgressSpinner v-if="loading" style="height: 2em;margin: 0 0 0 -2em;padding-top: 0.5em"/>
      <div class="login-input-wrapper" style="padding-top:1em;">
        <ResetChangePassword :user="user" :refresh-username="refreshUsername"
                             :showChangeDialogOriginal="showChangeDialog" @login="login"/>
      </div>
    </div>
  </div>
</template>

<script>
import LoginService from "../service/LoginService";
import SsoService from "../service/SsoService";
import ResetChangePassword from "../components/Common/ResetChangePassword";
import {useLoadingStore} from "@/store/loadingStore";
import {useUserStore} from "@/store/userStore";
import {useEndpointStore} from "@/store/endpointStore";
import {VueScreenSizeMixin} from 'vue-screen-size';
import {useApplicationStore} from "@/store/applicationStore";

export default {
  mixins: [VueScreenSizeMixin],
  components: {
    ResetChangePassword,
  },
  beforeCreate() {
    this.userStore = useUserStore()
    this.loadingStore = useLoadingStore()
    this.endpointStore = useEndpointStore()
    this.applicationStore = useApplicationStore()
  },
  created() {
    this.loginService = new LoginService();
    this.ssoService = new SsoService();
  },
  mounted() {
    this.$endpoints.refreshEndpoints();
    this.checkReset();
  },
  data() {
    return {
      username: null,
      password: null,
      loginExecuted: false,
      refreshUsername: 0,
      showChangeDialog: false,
      token: null,
    }
  },
  computed: {
    user() { return {username: this.username, password: this.password} },
    loading() { return this.loadingStore.loading },
  },
  methods: {
    login() {
      this.loadingStore.startLoading();
      this.$endpoints.refreshEndpoints();
      this.loginService.doLogin(this.username, this.password, this.applicationStore.applicationCode).then(token => {
        this.loadingStore.stopLoading();
        if (token != null && token.message == null) {
          this.userStore.setUser({
            token: token.jwt,
            refresh: token.refresh,
          });
          this.$endpoints.userInfo(token, this.$router, this)
        } else if (token != null) {
          this.$toast.add({
            severity: this.$t("toasts." + token.message + ".severity"),
            summary: this.$t("toasts." + token.message + ".summary"),
            detail: this.$t("toasts." + token.message + ".detail"),
            life: 4000
          });
        }
      }).catch(e => {
        this.loadingStore.resetLoading();
        const errorCode = e.response.data.message != null ? e.response.data.message : 'UNAUTHORISED';
        this.$toast.add({
          severity: 'error',
          summary: this.$t('toasts.' + errorCode + '.summary'),
          detail: this.$t('toasts.' + errorCode + '.detail'),
          life: 30000,
        });
        console.log('error authenticating', e);
      });
    },
    checkReset() {
      const tokenReset = this.$route.query["reset"]
      if (tokenReset != null) {
        const tokenData = JSON.parse(atob(tokenReset))
        this.username = tokenData.u
        this.password = tokenData.p
        this.showChangeDialog = true
      }
    }
  },
}
</script>

<style lang="scss" scoped>
@import "public/assets/sass/overrides/layout_variables";
.title1 {
  font-size: 28px;
  font-weight: 500;
  margin: 14px 0;
  color: grey!important;
}
.title2 {
  font-size: 28px;
  font-weight: 500;
  margin: 14px 0 0 .5em;
  color: $blue2!important;
}
.login-body {
  padding: 0;
  margin: 0;
  min-height: 100vh;

  .login-panel {
    display: none;
  }

  .login-content {
    position: fixed;
    padding: 80px 0;
    margin: 0 auto;
    width: 100%;
    height: 100%;
    text-align: center;

    img {
      display: inline-block;
      margin-bottom: 24px;
      width: 200px;
    }

    p {
      font-size: 17px;
      color: gray;
      margin: 0 0 32px 0;
    }

    .login-input-wrapper {
      position: relative;
      width: 300px;
      margin-bottom: 24px;
      text-align: center;
      margin-left: auto;
      margin-right: auto;

      input {
        width: 100%;
        padding-right: 16px;
      }

      i {
        position: absolute;
        color: gray;
        font-size: 16px;
        top: 50%;
        right: .429em;
        margin-top: -8px;
      }
    }

    button {
      min-width: 150px;
    }
  }
}

@media screen and (min-width: 768px) {
  .login-body {
    background: url("../../public/assets/layout/images/pages/login_bg.jpeg");
    background-size: cover;

    .login-panel {
      border: 5px solid $green1;
      padding: 80px;
      display: block;
      position: fixed;
      background-color: #ffffff;
      height: 200%;
      width: 100%;
      left: -50%;
      top: -50%;
      border-radius: 50%;
    }

    .login-content {
      text-align: left;
      position: fixed;
      padding: 80px 0 0 80px;

      .login-input-wrapper {
        width: 300px;
        margin-left: 0;
        margin-right: 0;
        text-align: left;
      }
    }
  }
}
</style>
